// extracted by mini-css-extract-plugin
export var animating = "_2f-3";
export var background = "_2f-6";
export var constrainHeight = "_2f-2";
export var dark = "_2f-4";
export var dropdown = "_2f-1";
export var leave = "_2f-5";
export var option = "_2f-7";
export var root = "_2f-0";